import TeamMembers from "../components/layout/home/our-team/TeamMembers";

const TeamMembersPage = (props) => {
  return <TeamMembers content={props.content} content2={props.content2} />;
};

export default TeamMembersPage;
